import { connect } from 'react-redux';

import LeftmeetingHomePageView from './LeftmeetingHomePageView';

import {
  mapStateToProps,
  mapDispatchToProps,
} from './props';

export default connect(mapStateToProps, mapDispatchToProps)(LeftmeetingHomePageView);
